import { Box, Button, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";
import { FAINT, MUTED } from "./ui";

/** "← {back label}" plus a plain "Project / … / …" trail. */
const Breadcrumb = ({ to, label, trail }: { to: string; label: string; trail: string[] }) => (
  <Box sx={{ mb: 1.5 }}>
    <Button
      component={Link}
      to={to}
      startIcon={<ArrowBackIcon />}
      sx={{ textTransform: "none", color: MUTED, ml: -1, minHeight: 44 }}
    >
      {label}
    </Button>
    <Typography variant="caption" component="p" sx={{ color: FAINT, overflowWrap: "anywhere" }}>
      {trail.join(" / ")}
    </Typography>
  </Box>
);

export default Breadcrumb;
